import React from 'react';
import colors from '../../config/colors';

const TextAreaQuestion = ({ question, value, onChange }) => {
  const charCount = value.length;
  const minLength = question.minLength || 0;
  const showCount = minLength > 0;

  return (
    <div style={{ padding: '12px 0' }}>
      <h2 style={{
        fontSize: 'clamp(1.5rem, 3vw, 2rem)',
        fontWeight: '700',
        color: colors.textPrimary,
        marginBottom: '8px',
        lineHeight: '1.2'
      }}>
        {question.question}
      </h2>

      {question.subtitle && (
        <p style={{
          fontSize: '1rem',
          color: colors.textSecondary,
          marginBottom: '20px'
        }}>
          {question.subtitle}
        </p>
      )}

      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={question.placeholder}
        rows={6}
        style={{
          width: '100%',
          padding: '18px 20px',
          fontSize: '1.05rem',
          lineHeight: '1.6',
          border: `2px solid ${colors.borderMedium}`,
          borderRadius: '12px',
          background: colors.bgCard,
          color: colors.textPrimary,
          outline: 'none',
          transition: 'all 0.3s ease',
          fontFamily: 'inherit',
          resize: 'vertical'
        }}
        onFocus={(e) => e.target.style.borderColor = colors.brandPrimary}
        onBlur={(e) => e.target.style.borderColor = colors.borderMedium}
      />

      {showCount && (
        <div style={{
          marginTop: '8px',
          fontSize: '0.85rem',
          color: charCount >= minLength ? colors.brandPrimary : colors.textMuted,
          textAlign: 'right'
        }}>
          {charCount >= minLength ? '✓ ' : ''}{charCount} / {minLength} characters
        </div>
      )}
    </div>
  );
};

export default TextAreaQuestion;
